import icon_wechat from './assets/icon-wechat.svg';
import icon_alipay from './assets/icon-alipay.svg';
import icon_upacp from './assets/icon-upacp.svg';
import { PayChannel } from '@/lib/pingpp';
export enum PayTypes {
  wechat = 'wechat',
  alipay = 'alipay',
  upacp = 'upacp',
  huabei = 'huabei',
}
export interface IHuabeiInfo {
  plan: IHuabeiTermInfo[];
  amount: number; // 分
}
export interface IHuabeiTermInfo {
  plan_id: number; // 期数
  rate: number; // 手续费 费率
  amount?: number; // 前端计算
}
export interface IPayType {
  type: PayTypes;
  icon: string;
  title: string;
  channel: PayChannel;
}
export const allChannels: { [key in PayTypes]: IPayType } = {
  wechat: {
    type: PayTypes.wechat,
    icon: icon_wechat,
    title: '微信支付',
    channel: PayChannel.WXPub,
  },
  alipay: {
    type: PayTypes.alipay,
    // icon: icon_alipay,
    icon: 'https://res.pandateacher.com/K47ZD6MT1623206609365.png',
    title: '支付宝支付',
    channel: PayChannel.AliPayQr,
  },
  upacp: {
    type: PayTypes.upacp,
    icon: icon_upacp,
    title: '银联支付',
    channel: PayChannel.UpacpWap,
  },
  huabei: {
    type: PayTypes.huabei,
    icon: 'https://res.pandateacher.com/O2XKTX291623727172865.png',
    title: '花呗分期',
    channel: PayChannel.huabei,
  },
};
export { default as ChannelSwitch } from './ChannelSwitch.vue';
export { default as ModalChannelSelect } from './ModalChannelSelect.vue';
